import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function for merging class names with Tailwind CSS
 *
 * This function combines clsx for conditional class names and
 * tailwind-merge to properly merge Tailwind utility classes
 *
 * @param inputs - Class names or conditional class expressions
 * @returns Merged class string
 *
 * @example
 * // Simple usage
 * cn('p-4', 'bg-red-500')
 *
 * @example
 * // With conditionals
 * cn(
 *   'p-4',
 *   isActive && 'bg-blue-500',
 *   !isActive && 'bg-gray-200'
 * )
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
